import PageContainer from '../components/PageContainer';
import PageTitle from '../components/PageTitle';
import desktopImage from '../static/images/chi_siamo_desktop.png';
import mobileImage from '../static/images/chi_siamo_mobile.png';
import { useTranslation } from "react-i18next";

const WhoWeAre = () => {
    const { t } = useTranslation();
    return (
        <PageContainer desktopItems="center">
            <PageTitle title="Chi siamo" />
            {/* Foto e titolo*/}
            <div className='flex flex-col md:flex-row-reverse items-center w-full xl:w-[1000px]'>
                {<div className='md:hidden'><img src={mobileImage} alt="Chi siamo mobile" /></div>}
                {<div className='hidden md:flex flex-[2]'><img src={desktopImage} alt="Chi siamo desktop" /></div>}
                <div className='font-signature text-[#b05704] flex-[1] flex justify-center text-3xl lg:text-3xl m-4'>{t('WhoWeAre.discoverWildSide')}</div>
            </div>
            {/* Testo */}
            <div className='w-full xl:w-[1000px] mx-4 pr-4'>
                <p>
                    {t('WhoWeAre.first')}
                </p>
                <p>
                    {t('WhoWeAre.second')}
                </p>
                <p>
                    {t('WhoWeAre.third')}
                </p>
            </div>

        </PageContainer>
    )
}

export default WhoWeAre